<template>
  <div>
    <template v-if="!show">
      <Loading size="100" />
    </template>
    <div :id="'mapid' + tripNumber" class="mapid"></div>
  </div>
</template>

<script>
import L from "leaflet";
import Loading from "@/components/Loading";

export default {
  name: "Map",
  components: {
    Loading
  },
  props: {
    tripNumber: Number,
    pickupAndDelivery: Array
  },
  data() {
    return {
      map: null,
      generalCoordinates: null,
      centerLatitude: null,
      centerLongitude: null,
      show: false
    };
  },
  async beforeMount() {
    let cityInfo = {};
    let from;
    let to;
    if (
      this.pickupAndDelivery[this.tripNumber - 1].from.city_from.includes(",")
    ) {
      from = this.pickupAndDelivery[this.tripNumber - 1].from.city_from.split(
        ","
      );
    } else {
      this.swal({
        title: "There is something wrong",
        text: "theres is not pickup state",
        icon: "error",
        dangerMode: true
      });
    }
    if (this.pickupAndDelivery[this.tripNumber - 1].to.city_to.includes(",")) {
      to = this.pickupAndDelivery[this.tripNumber - 1].to.city_to.split(",");
    } else {
      this.swal({
        title: "There is something wrong",
        text: "there is not delivery state",
        icon: "error",
        dangerMode: true
      });
    }
    cityInfo.haul_id = this.$store.getters["quotes/quote/showQuoteById"].haul[
      this.tripNumber - 1
    ].id;
    cityInfo.city_from = from[0];
    cityInfo.state_from = from[1];
    cityInfo.zipCode_from = this.pickupAndDelivery[
      this.tripNumber - 1
    ].from.zip_from;
    cityInfo.country_from = "US";
    cityInfo.city_to = to[0];
    cityInfo.state_to = to[1];
    cityInfo.zipCode_to = this.pickupAndDelivery[this.tripNumber - 1].to.zip_to;
    cityInfo.country_to = "US";
    let responseInfo = await this.$store.dispatch(
      "coordinatesMap/getCoordinatesMap",
      cityInfo
    );
    if (responseInfo.status == 200) {
      this.generalCoordinates = responseInfo.data;
    }
    this.centerLatitude =
      (this.generalCoordinates.latitude_from +
        this.generalCoordinates.latitude_to) /
      2;
    this.centerLongitude =
      (this.generalCoordinates.longitude_from +
        this.generalCoordinates.longitude_to) /
      2;
    this.show = true;
  },
  watch: {
    show() {
      if (this.show == true) {
        var greenIcon = new L.Icon({
          iconUrl:
            "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
          shadowUrl:
            "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
        });
        var redIcon = new L.Icon({
          iconUrl:
            "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
          shadowUrl:
            "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
        });
        this.map = L.map(`mapid${this.tripNumber}`).setView(
          [this.centerLatitude, this.centerLongitude],
          4.3
        );
        L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);
        L.marker(
          [
            this.generalCoordinates.latitude_from,
            this.generalCoordinates.longitude_from
          ],
          { icon: greenIcon }
        )
          .addTo(this.map)
          .bindPopup(
            this.pickupAndDelivery[this.tripNumber - 1].from.city_from
          );
        L.marker(
          [
            this.generalCoordinates.latitude_to,
            this.generalCoordinates.longitude_to
          ],
          { icon: redIcon }
        )
          .addTo(this.map)
          .bindPopup(this.pickupAndDelivery[this.tripNumber - 1].to.city_to);
        return this.$emit("input", true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mapid {
  width: 90%;
  height: 600px;
  @include justify-items-center;
}
</style>
